import Markdown from '../../../../builtin/components/Markdown';
import SimpleFlowEditor from '../../../../simpleFlow/SimpleFlowEditor';
import { EventPanelIcons } from "../../../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
import { VNodeDfs } from "../../../../../lib/comps/PropPanel/EventPanel/EventCardList/utils";
import { set } from "lodash-es";
import { DataSchemaTree } from "../../../../../lib/comps/DataSchemaTree";
import ExprInputAiProvider from "../../../../../lib/comps/ExprInput/addon/ExprInputAiProvider";
import DebounceConfig from './DecounceConfig';
const __script_base__ = {
  name: 'EventCard',
  components: {
    ExprInputAiProvider,
    Markdown,
    SimpleFlowEditor,
    DataSchemaTree,
    DebounceConfig
  },
  data() {
    return {
      arrowDownIcon: EventPanelIcons.arrowDownLight,
      deletIconUrl: EventPanelIcons.deleteIcon,
      selectedIcon: EventPanelIcons.selectedIcon,
      toggleExpand: true
    };
  },
  props: {
    flowCtxBase: {
      type: Object,
      required: true
    },
    eventKey: {
      type: String,
      required: true
    },
    eventMeta: {
      type: Object,
      default: null
    },
    value: {
      type: Object,
      required: true
    },
    changeable: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    argumentsSchemas() {
      var _this$eventMeta;
      return (_this$eventMeta = this.eventMeta) === null || _this$eventMeta === void 0 ? void 0 : _this$eventMeta.arguments;
    },
    argumentSchemaArray() {
      return (this.argumentsSchemas || []).map((item, index) => {
        const argKey = index === 0 ? '$event' : `flow.args[${index}]`;
        return {
          ...item,
          id: argKey
        };
      });
    },
    eventDescMarkdown() {
      return this.eventMeta.desc;
    },
    showEventMetaMarkdowns() {
      return this.eventMeta && this.eventDescMarkdown;
    },
    /** 控制descCard显示和descCard下面的分割线 */
    showDescCard() {
      return this.showEventMetaMarkdowns || this.argumentSchemaArray.length;
    },
    debounceTitle() {
      const cfg = this.value.debounceConfig;
      if (!cfg) return '配置防抖';
      if (cfg.type === 'throttle') return '节流';
      if (cfg.type === 'debounce') return '防抖';
      return '防抖';
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    changeDebounceConfig(val) {
      this.$emit('change', {
        ...this.value,
        debounceConfig: val
      });
    },
    expandAllSteps() {
      const expandAll = () => {
        let expandNum = 0;
        VNodeDfs(this.$refs.simpleFlowEditor, vnode => {
          if ('showParams' in vnode && vnode.showParams === !this.toggleExpand) {
            set(vnode, 'showParams', this.toggleExpand);
            expandNum += 1;
          }
        });
        return expandNum;
      };
      // 目前折叠的面板是v-if掉了 总不能全都渲染出来然后displaynone吧? 那一键展开只能这么搞了
      const interval = () => {
        setTimeout(() => {
          if (expandAll() > 0) {
            interval();
          } else {
            this.toggleExpand = !this.toggleExpand;
          }
        }, 0);
      };
      interval();
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-eventCard"
  }, [_c("div", {
    staticClass: "ucd-eventCard-header"
  }, [_c("div", {
    staticClass: "ucd-eventCard-eventName",
    attrs: {
      title: _vm.eventKey
    }
  }, [_vm._v("\n      事件: " + _vm._s(_vm.eventMeta && _vm.eventMeta.name || _vm.eventKey) + "\n    ")]), _vm._v(" "), _vm.changeable ? _c("div", {
    staticClass: "ucd-eventCard-btn-change"
  }, [_c("a-dropdown", {
    attrs: {
      "overlay-class-name": "ucd-addDropdown",
      trigger: ["click"]
    }
  }, [_c("i", {
    staticClass: "fa fa-random",
    staticStyle: {
      padding: "8px 2px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, [_vm._t("eventList")], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "ucd-eventCard-btn-debounce",
    attrs: {
      "data-enabled": !!_vm.value.debounceConfig
    }
  }, [_c("a-popover", {
    attrs: {
      trigger: "click",
      placement: "bottom"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("debounce-config", {
    attrs: {
      value: _vm.value.debounceConfig
    },
    on: {
      change: _vm.changeDebounceConfig
    }
  })], 1), _vm._v(" "), _c("div", [_c("i", {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.debounceTitle))])])], 2)], 1), _vm._v(" "), _c("div", {
    staticClass: "ucd-eventCard-btn-delete",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.$emit("delete");
      }
    }
  }, [_c("img", {
    attrs: {
      src: _vm.deletIconUrl
    }
  })]), _vm._v(" "), _c("a-tooltip", {
    attrs: {
      placement: "top",
      title: _vm.toggleExpand ? "展开全部" : "折叠全部"
    }
  }, [_c("div", {
    staticClass: "ucd-sfeStep-arrowButton ucd-sfeStep-arrowButton-expandAll",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.expandAllSteps.apply(null, arguments);
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-angle-double-down",
    class: {
      Rotate: !_vm.toggleExpand
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 1), _vm._v(" "), _vm.showDescCard ? _c("div", {
    staticClass: "ucd-eventCard-desc"
  }, [_vm.showEventMetaMarkdowns ? _c("Markdown", {
    attrs: {
      source: _vm.eventDescMarkdown,
      "open-in-new-window": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.argumentSchemaArray, function (item, index) {
    return _c("data-schema-tree", {
      key: index,
      attrs: {
        "data-schema": item,
        "root-title": "参数: "
      }
    });
  })], 2) : _vm._e(), _vm._v(" "), _vm.showDescCard ? _c("a-divider", {
    staticClass: "ucd-eventCard-divider"
  }) : _vm._e(), _vm._v(" "), _c("expr-input-ai-provider", {
    staticClass: "ucd-eventCard-content",
    attrs: {
      "event-arg": _vm.argumentSchemaArray
    }
  }, [_c("SimpleFlowEditor", {
    ref: "simpleFlowEditor",
    attrs: {
      "flow-ctx-base": _vm.flowCtxBase,
      value: _vm.value,
      "arguments-schemas": _vm.argumentsSchemas
    },
    on: {
      change: function ($event) {
        return _vm.$emit("change", $event);
      }
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/EventCardList/EventCard.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);